{
  "upload": {
    "title": "Ihre Marke",
    "subtitle": "Laden Sie Ihr Markenbild hoch oder geben Sie eine Wortmarke ein",
    "selectType": "Welche Option beschreibt Ihre Marke am besten?",
    "logoTrademark": "Logo-Marke",
    "logoDescription": "Markenlogo einschließlich Text",
    "figurativeTrademark": "Bildmarke",
    "figurativeDescription": "Grafische Elemente der Marke ohne Text",
    "wordTrademark": "Wortmarke",
    "wordDescription": "Markenname oder Slogan",
    "uploadYour": "Laden Sie Ihre {{type}}-Marke hoch",
    "dragDrop": "Ziehen Sie Ihr Bild hierher oder",
    "browseFiles": "Dateien durchsuchen",
    "supportedFormats": "Unterstützte Formate: PNG, JPG, GIF",
    "enterWordMark": "Geben Sie Ihre Wortmarke ein",
    "wordPlaceholder": "Geben Sie Ihren Markentext ein",
    "uploadWordMark": "Wortmarke hochladen",
    "removeImage": "Bild entfernen",
    "uploading": "Marke wird hochgeladen...",
    "uploadSuccess": "Marke erfolgreich hochgeladen!",
    "imageSuccess": "Bildmarke erfolgreich hochgeladen",
    "uploadDifferent": "Andere Marke hochladen",
    "selectImage": "Wählen Sie ein Bild zum automatischen Hochladen",
    "uploadError": "Fehler beim Hochladen der Marke. Bitte versuchen Sie es erneut."
  },
  "analysis": {
    "title": "KI-gestützte Analyse",
    "subtitle": "Unsere KI analysiert Ihre Marke auf Unterscheidungskraft, potenzielle Konflikte und Registrierungsstrategie",
    "readyTitle": "Bereit für die KI-gestützte Markenanalyse",
    "readySubtitle": "Unsere KI analysiert Ihre Marke auf Unterscheidungskraft, potenzielle Konflikte und Registrierungsstrategie",
    "yourTrademark": "Ihre Marke",
    "trademarkRequired": "Marke erforderlich",
    "businessProfile": "Unternehmensprofil",
    "businessRequired": "Unternehmensprofil erforderlich",
    "trademarkName": "Markenname",
    "trademarkNameDesc": "Dies ist der Name oder Text, der unter Ihrer Markenregistrierung geschützt wird",
    "trademarkType": "Markentyp",
    "logoTypeDesc": "Ein visuelles Design oder Logo, das Ihre Marke repräsentiert",
    "wordTypeDesc": "Ein Wort oder eine Phrase, die Ihre Waren oder Dienstleistungen identifiziert",
    "detailedDescription": "Detaillierte Beschreibung",
    "trademarkDescription": "Markenbeschreibung",
    "viewDescription": "Detaillierte Markenbeschreibung anzeigen",
    "descriptionHelp": "Diese Beschreibung hilft unserer KI, die visuellen und konzeptuellen Elemente Ihrer Marke zu verstehen",
    "descRequired": "Beschreibung erforderlich",
    "descRequiredMsg": "Bitte fügen Sie eine detaillierte Beschreibung Ihrer Marke hinzu, um mit der Analyse fortzufahren",
    "descRequiredHelp": "Eine gute Beschreibung enthält Farben, Designelemente, Schriftarten und das allgemeine Erscheinungsbild",
    "noTrademark": "Keine Marke ausgewählt",
    "noTrademarkMsg": "Bitte vervollständigen Sie zuerst den Marken-Upload-Schritt",
    "noTrademarkHelp": "Sie müssen Ihre Marke hochladen, bevor wir sie analysieren können",
    "readyToAnalyse": "Bereit zur Analyse",
    "analyseButton": "Meine Marke analysieren",
    "analysing": "Analyse Ihrer Marke...",
    "analysisComplete": "Analyse abgeschlossen",
    "viewReport": "Vollständigen Bericht anzeigen",
    "overallScore": "Gesamtbewertung",
    "distinctiveness": "Unterscheidungskraft",
    "conflictRisk": "Konfliktrisiko",
    "registrability": "Registrierbarkeit",
    "recommendations": "Empfehlungen",
    "potentialConflicts": "Potenzielle Konflikte",
    "noConflicts": "Keine signifikanten Konflikte gefunden",
    "needsUpload": "Sie müssen Ihre Marke hochladen, bevor wir sie analysieren können",
    "classRecommendations": "Klassenempfehlungen",
    "suggestedClasses": "Empfohlene Nizza-Klassen"
  },
  "business": {
    "title": "Geschäftsinformationen",
    "complete": "Geschäftsinformationen vollständig",
    "completeDescription": "Ihre Geschäftsinformationen wurden erfolgreich gespeichert und werden verwendet, um genaue Markenempfehlungen zu geben.",
    "subtitle": "Erzählen Sie uns von Ihrem Unternehmen, damit Marko personalisierte Empfehlungen geben kann",
    "ownerType": "Markeninhabertyp",
    "individual": "Einzelperson",
    "company": "Unternehmen",
    "partnership": "Partnerschaft",
    "businessName": "Firmenname",
    "tradingAs": "Handelsname",
    "registrationNumber": "Registrierungsnummer",
    "industry": "Branche",
    "selectIndustry": "Wählen Sie Ihre Branche",
    "goodsServices": "Waren und Dienstleistungen",
    "describeGoodsServices": "Beschreiben Sie die Waren oder Dienstleistungen, die Ihre Marke abdecken wird",
    "markoAnalyse": "Marko analysiert Ihre Informationen während Sie tippen.",
    "analysed": "Ich habe Ihre Marke analysiert"
  },
  "classes": {
    "title": "Nizza-Klassifikation",
    "subtitle": "Wählen Sie die Klassen, die Ihre Waren und Dienstleistungen am besten beschreiben",
    "selectedClasses": "Ausgewählte Klassen",
    "noClassesSelected": "Keine Klassen ausgewählt",
    "addClass": "Klasse hinzufügen",
    "removeClass": "Klasse entfernen",
    "searchClasses": "Klassen suchen...",
    "classNumber": "Klasse {{number}}",
    "viewDetails": "Klassendetails anzeigen"
  }
}
